import {ModuleComponent} from "../../js/module-component";

export class ModFooter extends ModuleComponent{

    ready(){
        super.ready();

        var $body = $("body");
        if($(".js-sidebar__inner").length>0){
            inView(this.scope)
            .on('enter', ()=>{
                $body.addClass("has-footer-in");
                var $sidebar = $(".js-sidebar__inner");
                $sidebar.css("top",this.$root.offset().top-150-$sidebar.height());
            })
            .on('exit', ()=>{
                $body.removeClass("has-footer-in");
                $(".js-sidebar__inner").css("top","");
            });


            //if header is not in viewport we add class to body
            if(inView.is(this.$root.get(0)))
                $body.addClass("has-footer-in");
        }
    }
}
